<ng-container *ngIf="vm$ | async as vm">
  <dgx-dfb-form
    [fieldset]="vm.formBuilderConfig"
    [form]="vm.form"
  ></dgx-dfb-form>
</ng-container>
